import React, { useState } from "react";
import emailjs from "emailjs-com";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SendIcon from "@mui/icons-material/Send";
import EmailIcon from "@mui/icons-material/Email";

const EmailForm = (props) => {
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    const mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (props.message.length !== 0 && email.match(mailformat) && !submitted) {
      // service_id, templete_id, form_data, user_id
      emailjs
        .send(
          "service_bt8a4bq",
          "template_zde1k4m",
          { reply_to: email, message: props.message },
          "user_hRdglUYWevKBS7diG6AaR"
        )
        .then(
          (result) => {
            console.log("Success!", result.text);
          },
          (error) => {
            console.log("Failed...", error.text);
          }
        );

      setSubmitted(true);
    }
  };

  const changeHandler = (e) => {
    setEmail(e.target.value);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        maxWidth: 640,
        mx: "auto",
        mt: 6,
        mb: 4,
        p: { xs: 3, sm: 4 },
        borderRadius: 4,
        border: "1px solid rgba(123, 31, 162, 0.1)",
        background:
          "linear-gradient(135deg, rgba(123, 31, 162, 0.03) 0%, rgba(224, 64, 251, 0.03) 100%)",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
              "linear-gradient(135deg, rgba(123, 31, 162, 0.12) 0%, rgba(224, 64, 251, 0.12) 100%)",
          }}
        >
          <EmailIcon
            sx={{ fontSize: 20, color: "primary.main" }}
          />
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: { xs: "1rem", sm: "1.125rem" },
            color: "text.primary",
          }}
        >
          Save Your Resources
        </Typography>
      </Box>

      {!submitted ? (
        <Box
          component="form"
          onSubmit={sendEmail}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1.5,
              alignItems: "flex-start",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <TextField
              id="email-input"
              type="email"
              value={email}
              onChange={changeHandler}
              placeholder="Enter your email address"
              fullWidth
              size="medium"
              aria-describedby="email-helper-text"
              sx={{
                flex: 1,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "background.paper",
                },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              onClick={sendEmail}
              endIcon={<SendIcon sx={{ fontSize: "18px !important" }} />}
              sx={{
                minWidth: { xs: "100%", sm: 140 },
                whiteSpace: "nowrap",
                py: 1.5,
              }}
            >
              Send
            </Button>
          </Box>

          <Typography
            id="email-helper-text"
            variant="body2"
            sx={{
              color: "text.secondary",
              fontSize: "0.8125rem",
              lineHeight: 1.5,
              opacity: 0.8,
            }}
          >
            Send these resources to your email! Your email is not stored
            anywhere and is not shared or collected by anyone.
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
            py: 2,
            px: 3,
            borderRadius: 3,
            backgroundColor: "rgba(76, 175, 80, 0.08)",
            border: "1px solid rgba(76, 175, 80, 0.2)",
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 28, color: "success.main" }}
          />
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: { xs: "1rem", sm: "1.125rem" },
              color: "success.main",
            }}
          >
            Email Sent!
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default EmailForm;
